import { useState } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import CourseStats from '../components/CourseStats';
import SimulatedClient from '../components/SimulatedClient';
import Roadmap from '../components/Roadmap';
import CourseContent from '../components/CourseContent';
import Deliverables from '../components/Deliverables';
import Mentor from '../components/Mentor';
import TargetAudience from '../components/TargetAudience';
import Testimonials from '../components/Testimonials';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';
import PaymentMethods from '../components/PaymentMethods';
import LeadForm from '../components/LeadForm';
import Footer from '../components/Footer';
import FloatingWhatsApp from '../components/FloatingWhatsApp';
import ScrollToTop from '../components/ScrollToTop';
import Modal from '../components/Modal';
import AnnouncementBar from '../components/AnnouncementBar';

export default function BrandingPage({ theme, toggleTheme }) {
  const [modalContent, setModalContent] = useState(null);
  const openModal = (type) => setModalContent(type);
  const closeModal = () => setModalContent(null);

  return (
    <div className="flex flex-col relative w-full">
      <div className="sticky top-0 z-50 flex flex-col w-full shadow-md">
        <AnnouncementBar />
        <Navbar theme={theme} toggleTheme={toggleTheme} />
      </div>
      <main className="flex-grow -mt-20">
        <Hero />
        //<CourseStats />
        <Roadmap />
        <CourseContent />
        <SimulatedClient />
        <Deliverables />
        <Mentor />
        <TargetAudience />
        <Testimonials />
        <Pricing />
        <FAQ />
        <PaymentMethods />
        <LeadForm openModal={openModal} />
      </main>
      <Footer openModal={openModal} />
      <FloatingWhatsApp />
      <ScrollToTop />
      <Modal content={modalContent} onClose={closeModal} />
    </div>
  );
}
